(function($) {

    $.fn.togglePanel = function(options) {
        // build main options before element iteration
        var opts = $.extend( {}, $.fn.togglePanel.defaults, options);

        return this.each(function() {

            var eOpts = $.metadata ? $.extend(true, {}, opts, $(this).metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend(true, eOpts, $(this).dataset()) : eOpts;

            var $panel = $(this).find(".panel-content");
            var $toggle = $(this).find(".panel-toggle");
            var $icon = $toggle.find(".ui-icon");

            var title = $(this).find("span.ui-icon-text:first").text();
            var showTitle = translate('Show {0}', [title]);
            var hideTitle = translate('Hide {0}', [title]);

            var isCallapsed = isCollapsed();
            $toggle.attr('title', isCallapsed ? hideTitle : showTitle);

            $toggle.css('cursor', 'pointer');
            toggle(!isCallapsed, true);

            $toggle.click(function(){
                toggle(isCollapsed(), false);
            });

            function isCollapsed() {
                return $panel.hasClass("collapsed");
            }

            function toggle(show, init) {
                if (show) {
                    $icon.attr('data-icon', 'ui-icon-carat-1-n');
                    $icon.removeClass('ui-icon-carat-1-s').addClass('ui-icon-carat-1-n');

                    if (init) {
                        $panel.slideDown(0);
                    } else {
                        $panel.slideDown("fast", afterSlide);
                    }

                    $panel.removeClass('collapsed').addClass("expanded");
                    $toggle.tooltip({content : hideTitle});
                } else {
                    $icon.attr('data-icon', 'ui-icon-carat-1-s');
                    $icon.addClass('ui-icon-carat-1-s').removeClass('ui-icon-carat-1-n');
                    if (init) {
                        $panel.slideUp(0);
                    } else {
                        $panel.slideUp("fast", afterSlide);
                    }
                    $panel.addClass('collapsed').removeClass("expanded");
                    $toggle.tooltip({content : showTitle});
                }
            }

            function afterSlide() {
                $(window).trigger('updateStalker');
                // Recalculate size of waypoint wrapper
                $panel.closest('.sticky-wrapper').children().waypoint('resize');
            }
        });
    };

})(jQuery);